import { string } from 'prop-types';

let langData = {};

if (false) {
  import('./en/loader.js')
  import('./vi/loader.js')
}

export async function initLang() {
  const langCode = localStorage.getItem("lang") || "en";
  let module = await import(`./${langCode}/loader.js`)
  langData = module.default;
}

export function setLang(langCode) {
  localStorage.setItem("lang", langCode);
  window.location.reload(); // Bạn reload là được load lang mới
}

export function lang(key) {
  try {
    key = String(key)
    if (langData[key] !== undefined) {
      return langData[key];
    } else if (!key.includes("{")) {
      return key;
    } else {
      return key.replace(/{([^}]+)}/g, (match, group) => {
        return langData[group] || match;
      })
    }
  }
  catch (e) {
    console.error("Error in lang function:", e);
    return key;
  }
}
